import { Component } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from '../../../../auth/auth.service';
import { UserDto } from '../../../../auth/user.dto';
import { ContractEngagementType, labelsByAllContractEngagementType } from '../../../../shared/models/enums/contract-engagement-type.enum';
import {
  ContractType,
  labelsByAllContractType,
  labelsByRsaTypedContractType,
  labelsByWorkflowedTypedContractType,
} from '../../../../shared/models/enums/contract-type.enum';
import { StringUtils } from '../../../../shared/services/stringUtils.service';
import { DisplayTraceabilityDto } from '../../../../shared/traceability/display-traceability.dto';
import { BeneficiaryDto } from '../../../dto/beneficiary.dto';
import { ContractDto } from '../contract.dto';

type AllContractType = ContractType | ContractEngagementType;

@Component({
  selector: 'app-contract-wrapper',
  templateUrl: './contract-wrapper.component.html',
  styleUrl: './contract-wrapper.component.scss',
  standalone: false,
})
export class ContractWrapperComponent {
  public contract: ContractDto;
  public beneficiary: BeneficiaryDto;

  public selectedType: AllContractType | null = null;
  public contractTypes: string[] = [];
  public isWorkflowedContract: boolean;

  public isEngagementContract: boolean = false;

  public contractWrapForm: UntypedFormGroup;

  public traceability: DisplayTraceabilityDto[] = [];

  public stringAscOrder = StringUtils.stringAscOrder;
  private readonly destroy$: Subject<void> = new Subject();

  // *********************************************************************************************
  // * NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG *
  // * NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG NG *
  // *********************************************************************************************

  constructor(
    private readonly authService: AuthService,
    private readonly formBuilder: FormBuilder,
    private readonly modal: NgbActiveModal,
  ) {}

  public async onInit(beneficiary: BeneficiaryDto, contract?: ContractDto, contractSelectable?: string[]): Promise<void> {
    this.beneficiary = beneficiary;
    this.contract = contract;
    this.isWorkflowedContract =
      labelsByWorkflowedTypedContractType.includes(contract?.contractType) ||
      labelsByAllContractEngagementType.includes(contract?.contractType as any);

    this.traceability = this.contract ? this.contract.traceability : [];

    const user: UserDto = await this.authService.getUser();
    if (!contract?.id) {
      if (user?.groups.includes('TERRITORY')) {
        this.contractTypes = [...labelsByRsaTypedContractType, ...labelsByAllContractEngagementType];
      } else {
        this.contractTypes = [...labelsByAllContractType, ...labelsByAllContractEngagementType];
      }
    } else {
      if (labelsByAllContractEngagementType.includes(contract.contractType as ContractEngagementType)) {
        this.contractTypes = labelsByAllContractEngagementType;
        this.isEngagementContract = true;
      } else {
        this.contractTypes = this.isWorkflowedContract ? labelsByAllContractType : labelsByRsaTypedContractType;
        this.isEngagementContract = false;
      }
    }
    this.contractTypes = this.contractTypes.filter((type) => !contractSelectable || contractSelectable.includes(type));
    this.loadForm();
  }

  // *********************************************************************************************
  // * FORM FORM FORM FORM FORM FORM FORM FORM FORM FORM FORM FORM FORM FORM FORM FORM FORM FORM *
  // * FORM FORM FORM FORM FORM FORM FORM FORM FORM FORM FORM FORM FORM FORM FORM FORM FORM FORM *
  // *********************************************************************************************

  public loadForm() {
    this.contractWrapForm = this.formBuilder.group({
      contractType: [{ value: this.contract?.contractType, disabled: this.isWorkflowedContract }, [Validators.required]],
    });

    this.contractWrapForm.controls.contractType.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value: ContractType) => this.handleTypeChange(value));
  }

  public handleTypeChange(type: AllContractType) {
    this.isEngagementContract = labelsByAllContractEngagementType.includes(type as ContractEngagementType);
  }

  // *********************************************************************************************
  // * MODAL MODAL MODAL MODAL MODAL MODAL MODAL MODAL MODAL MODAL MODAL MODAL MODAL MODAL MODAL *
  // * MODAL MODAL MODAL MODAL MODAL MODAL MODAL MODAL MODAL MODAL MODAL MODAL MODAL MODAL MODAL *
  // *********************************************************************************************

  public cancel(): void {
    this.contractWrapForm.reset();
    this.modal.close();
  }
}
